<!-- page starts-->
<section class="page-wrapper">
  <div class="ashton-hero-top-detail cf">
    <div class="container">
      <div class="ashton-hero-center-detail videos cf">
        <div class="red-titel">VIDEOS</div>
        <div class="ashton-hero-center-video-detail cf">
          <div class="ashton-hero-center-video-detail-inner cf">
            <div class="ashton-hero-center-video-box" *ngFor="let video of videoList">
              <div class="ashton-hero-center-video-image">
                <a class="popup-youtube" href="{{video?.video}}"> <img [src]="video?.image" alt="new-img"></a>
              </div>
              <div class="ashton-hero-center-video-content-box">
                <div class="ashton-hero-center-video icon">
                  <a class="popup-youtube" href="{{video?.video}}"><img src="assets/images/play-button.png"
                      alt="play-button"></a>
                  <h3>{{video?.title}}</h3>
                </div>
                <p>{{video?.created_at | amDateFormat:'MMM DD, YYYY'}}</p>
              </div>
            </div>
          </div>
          <div class="ashton-hero-center-video-btn">
            <a (click)="getMoreVideo()">LOAD MORE</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section><!-- page ends-->
<!-- <div class="video-popup-section forlogin-section  mfp-hide" id="video-popup">
  <div class="add-popup cf">
      <div class="container">
         <div class="video-popup-detail">
            <div class="sound-btn">
                    <a href="javascript:void(0)" id="videos">
                        <span class="mute"><img src="assets/images/mute.svg"></span>
                        <span class="audio-play"><img src="assets/images/audio-speaker-on.svg"></span>
                    </a>
            </div>
            <div class="video">
              <video loop muted autoplay playsinline oncanplay="this.play()" onloadedmetadata="this.muted = true" id="video">
                <source src="assets/images/Ashton United Vs Mickleover Sports FC  Match Highlights.mp4" type="video/mp4">
              </video>
            </div>
         </div>
      </div>
  </div>
</div> -->